import React from 'react';

import IconButton from 'ds/IconButton';
import Layout, { Props as LayoutProps } from 'ds/Layout';
import { EditablePdf } from 'shared';

import MessagePdfThumbnail from './MessagePdfThumbnail';

interface Props {
  onDeleteClick?: VoidFunction;
  pdf: EditablePdf;
  disabled?: boolean;
  containerProps?: LayoutProps;
}

const MessagePdfUploadThumbnail: React.FC<Props> = ({ onDeleteClick, pdf, disabled, containerProps }) => {
  const filename = pdf.filename || pdf.file?.name || 'Untitled PDF';
  const filesize = pdf.filesize || pdf.file?.size;

  return (
    <Layout position="relative" {...containerProps}>
      <MessagePdfThumbnail
        onClick={() => {
          // Handle PDF click - could open in new tab or download
          if (pdf.url) {
            window.open(pdf.url, '_blank');
          } else if (pdf.file) {
            const url = URL.createObjectURL(pdf.file);
            window.open(url, '_blank');
            URL.revokeObjectURL(url);
          }
        }}
        filename={filename}
        filesize={filesize}
        showDownloadIcon={!onDeleteClick}
        style={{
          width: containerProps?.width,
          height: containerProps?.height
        }}
      />
      {!!onDeleteClick && (
        <Layout position="absolute" right={4} top={4}>
          <IconButton size="xs" type="gray" name="close" stroke={2} disabled={disabled} onClick={onDeleteClick} />
        </Layout>
      )}
    </Layout>
  );
};

export default MessagePdfUploadThumbnail;
